module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "airports-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-airportprices",
      "to": {
        name: 'AirportPrices'
      },
      "md-label": "Список"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-airportluwprices",
      "to": {
        name: 'AirportLuwPrices'
      },
      "md-label": "Список ПРР"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-settings",
      "to": {
        name: 'AirportPricesSettings'
      },
      "md-label": "Настройки"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c3a3faf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/airport/AirportsMenu.vue
// module id = 1114
// module chunks = 0